<template>
  <div class="grid" v-if="show">
    <div v-for="i in count" :key="i"/>
  </div>
</template>

<script>
export default {
  name: 'LayoutGrid',
  data() {
    return {
      show: false
    };
  },
  computed: {
    count() {
      const size = 80;
      return (1280 / size) * (800 / size);
    }
  },
  mounted() {
    if (location.hostname !== 'localhost') {
      return;
    }
    document.addEventListener('keyup', e => {
      if (e.ctrlKey && e.key === `'`) {
        this.show = !this.show;
      }
    }, false);
  }
};
</script>

<style scoped>
  .grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, var(--grid-size));
    grid-template-rows: repeat(auto-fill, var(--grid-size));
    position: absolute;
    top: 0;
    left: 0;
    width: 1280px;
    height: 800px;
    z-index: 1;
    pointer-events: none;
  }

  .grid div {
    border: 1px solid rgba(222,222,222,0.5);
  }
</style>
